<template>
  <label class="app-checkbox" :class="{ active, disabled }">
    <div class="app-checkbox__body">
      <input
        type="checkbox"
        ref="input"
        :disabled="disabled"
        :checked="active"
        @change="handleChange"
      />
      <div class="app-checkbox__icon">
        <checkbox-icon />
      </div>
    </div>
    <span class="app-checkbox__text"><slot></slot></span>
  </label>
</template>

<script>
import checkboxIcon from '@/assets/svg/checkbox.svg?component'
export default {
  name: 'AppCheckbox',
  components: { checkboxIcon },
  props: ['modelValue', 'disabled'],
  data() {
    return {
      active: false,
    }
  },
  mounted() {
    if (this.$props['modelValue']) {
      this.handleChange()
    }
  },
  methods: {
    handleChange() {
      this.active = !this.active
      this.$emit('update:modelValue', this.active)
    },
  },
}
</script>
